import * as d3 from 'd3'
import utils from '../utils'
import filesaver from "file-saver"

import structs from '../structures.js'
import globals from '../globals.js'

import naics from '../assets/mecs_naics.js'

/*
function copy_node(n1,suffix="_copy"){
  var id = utils.get_new_index(nodes)
  var n2 = new structs.Node()
  n2.copyObject(n1)
  n2.index=id

  n2.name+=suffix
  nodes[n2.index]=n2
  node_by_name[n2.name]=n2
  n1.parent.children.push(n2)
  return n2
}
*/

var exports = {}

exports.load_csvs = (nodes_raw,links_raw)=>{
  var nodes = {}
  var links = {}
  var node_by_name = {}

  nodes_raw.forEach((node)=>{
    Object.keys(node).forEach( k=>{ node[k.toLowerCase()]=node[k]})
    var id = node.id
    var n = new structs.Node()
    n.copyObject(node)
    n.index=id
    nodes[id] = n
    var ncode = naics.codes[n.name]
    if (ncode){
      n.naics_code = ncode
    }
    node_by_name[n.name.toLowerCase()]=n
  })

  var specials = ["*waste*","*energy services*","ghost quads"]
  specials.forEach(s=>{
    var n = new structs.Node()
    n.name=s
    n.index=utils.get_new_index(nodes)
    nodes[n.index]=n
    node_by_name[s]=n
  })


  links_raw.forEach( (link,id)=>{
    var src = nodes[link.SOURCE_ID]
    var tgt = nodes[link.TARGET_ID]
    if (src && tgt){ //source and target are ids here as stored in data struct?
      var l = new structs.Link(id,src,tgt,link.VALUE,link.REFERENCE)
      links[id]=l
      if(l.reference){
        var r = l.reference.toLowerCase()
        if(r.includes("consumption/manufacturing") || r.includes("pub39685") || r.includes("forecasts/aeo/data/browser/#/?id=43")  || r.includes("lbnl-1005775") || r.includes("id=18431") || r.includes("ecn_2012_us_23sg01") || r.includes("mining_bandwidth")){
          l.dataSource = "MECS"
        }else if (r.includes("consumption/commercial") || r.includes("pdf/550009.pdf")){
          l.dataSource = "CBECS"
        }else if (r.includes("consumption/residential")){
          l.dataSource = "RECS"
        }else if (r.includes("forecasts/aeo/data/browser/#/?id=7") || r.includes("det/extraction3") || r.includes("pdf/537889")){
          l.dataSource = "NHTS"
        }else if (r.includes("opendata/qb") || r.includes("sec2_14.pdf")){
          l.dataSource = "FEMP"
        }else if (r.includes("iiasa.ac.at")){
          l.dataSource = "GTAP"
        }
      }
      src.source_links.push(l)
      tgt.target_links.push(l)
    }
  })


  var dsts=[node_by_name['*waste*'],node_by_name['*energy services*']]

  node_by_name['ghost quads'].is_reserves=true
  var stories = []
  Object.values(nodes).forEach(n=>{
    if (n.story_pct){
      stories.push(n)
      var nxt = new Set()
      var start = n
      start.source_links.forEach(l=>{
        nxt.add(l.target)
        l.value *= n.story_pct
      })


      nxt.forEach(n=>n.source_links.forEach(l=>l.value*=1./3))
    }
  })

  stories.forEach(n=>{
    var node = new structs.Node()
    var id = utils.get_new_index(nodes)
    node.index=id
    var name = "*story*_" + n.name
    node.copyObject({"name":name,"column":(n.column+1)})
    node_by_name[name]=node
    nodes[id]=node
    node.is_story=true
  })

  /*
  var killme = [
    'ghost quads',
    'energy materials in products',
    'petroleum refineries',
    'oil and natural gas extraction',
    'pipeline fuel natural gas',
    'commercial electricity loss',
    'petroleum stock',
    'coal stock change',
    'government electricity loss',
    'transportation electricity loss',
    'industrial electricity loss',
    'coal net exports',
    'residential electricity loss',
    'electricity used in generation',
    'freight-rail coal',
    'eliminated by leds',
    'eliminated by light truck electrification',
    'eliminated by freight truck electrification',
    'eliminated by car electrification',
    'fossil mining equipment'
  ]

  killme.forEach(n=>{
    node_by_name[n].is_reserves=true
  })

  var reflow=['cars','light trucks']

  var nxt = new Set()
  reflow.forEach(n=>{
    var start = node_by_name[n]
    start.source_links.forEach(l=>{
      nxt.add(l.target)
      l.value*=1./3
    })
  })

  nxt.forEach(n=>n.source_links.forEach(l=>l.value*=1./3))
  */


  Object.values(nodes).forEach( n=> {
    if(n.waste_percentage > 0.){
      var vals=[n.waste_percentage,1.-n.waste_percentage]
      var nval = n.get_tgt_value() - n.get_src_value()
      if(nval>1e-3){
        dsts.forEach( (d,dstid)=>{
          var id = utils.get_new_index(links)
          var l =new structs.Link(id,n,d,nval*vals[dstid],"",!dstid)
          n.source_links.push(l)
          d.target_links.push(l)
          links[id]=l
        })
      }
    }

    if(n.name!="*waste*" && n.name!="*energy services*" && !n.source_links.length){
      var id = utils.get_new_index(links)
      var vv = n.get_value()
      if(vv > 1e-3){
        var l=new structs.Link(id,n,dsts[1],vv,"",false)
        dsts[1].target_links.push(l)
        n.source_links.push(l)
        links[id]=l
      }
    }
  })


  //initialize basic columns
  var remainingNodes = Object.values(nodes),
      nextNodes,
      x = 0;


  Set.prototype.difference = function(setB) {
      var difference = new Set(this);
      for (var elem of setB) {
          difference.delete(elem);
      }
      return difference;
  }

  var placed = []

  var iters = 0
  while (remainingNodes.length && iters < 1e5) {
    ++iters
    if (iters >=1e5){
      console.log("FAIL")
    }
    nextNodes = [];
    remainingNodes.forEach( (node)=>{
      node.source_links.forEach( (link)=>{
        if (nextNodes.indexOf(link.target) < 0) {
          nextNodes.push(link.target);
        }
      });
    });

    nextNodes.forEach( n=>{n.column = x+1})

    var s1 = new Set(remainingNodes)
    var s2 = new Set(nextNodes)
    var diff = s1.difference(s2)
    for (let item of diff){
      item.column=x
    }
    remainingNodes = nextNodes;

    ++x;
  }


  function make_accumulated_nodes(node_name){
    var mx_id = utils.get_new_index(nodes)
    for(var i =0; i < x-1; ++i){
      var id = mx_id+i
      var name =node_name+"_"+ (i+1).toString()
      var node = new structs.Node()
      node.index=id
      node.tags={}
      node.copyObject({"name":name,"column":(i+1)})
      node.datasource = ()=>{return ["implicit"]}
      node_by_name[name]=node
      nodes[id]=node
    }
  }

  make_accumulated_nodes("*waste*")
  make_accumulated_nodes("*energy services*")

  var linklen = utils.get_new_index(links)-1


  var populateAmts = (n,key,amt,is_down)=>{
    var front = []
    front = [...(is_down ? n.source_links : n.target_links)]
    var n_front = []
    var seen = {}
    while(front.length > 0){
      front.forEach((l)=>{
        var relevant_node = is_down ? l.target : l.source
        var opposite_node = is_down ? l.source : l.target
        var relevant_links = is_down ? relevant_node.source_links : relevant_node.target_links
        var v1 = opposite_node[amt][key]
        var v2 = (l.value/opposite_node.get_value())
        relevant_node[amt][key] += v1*v2
        if(seen[relevant_node.index]!=1 && relevant_links.length > 0){
          n_front = n_front.concat(relevant_links)
        }
        seen[relevant_node.index]=1
      })
      front = [...n_front]
      n_front = []
    }
  }


  var compoundNodes = {}
  Object.keys(nodes).forEach( (k) => {
    compoundNodes[k] = new structs.CompoundNode([nodes[k]]);
    compoundNodes[k].index = k
    nodes[k].origin = compoundNodes[k]
    nodes[k].parent = compoundNodes[k]
  })

  var linksort = (l1,l2) => {
    var l1v = l1.value
    if (l1.losses)
      l1v -= 1e3
    var l2v = l2.value
    if (l2.losses)
      l2v -= 1e3
    return l1v - l2v
  }



  var curkeys = Object.keys(nodes)
  /*
  curkeys.forEach( (k) => {
    var n = nodes[k]
    if( d3.sum(globals.overheads,(o)=>{return n[o]['pct']}) >0 ) {
      var base_value = n.get_value() //where this node starts originally
      globals.overheads.filter((o)=>{return n[o]['pct'] > 0}).forEach( (o) => {
        var new_n = copy_node(n," for " + o.split("_")[0] + " production/distribution")
        reduceUpstream(new_n,o,base_value,new_n[o])
        var p_and_d = "produced and distributed "+ o.split("_overhead")[0].replace("_"," ")
        var pdnode = node_by_name[p_and_d.toLowerCase()]
        utils.move_node(new_n,pdnode)
      })
    }
  })
  */


  /*
  Object.values(nodes).filter( (n) => {return n.name.includes("electricity loss")}).forEach( (n) =>{
    var nn = node_by_name[n.name.split("electricity loss")[0] + "sector"]

    //utils.move_node(n,node_by_name["waste_"+(n.column).toString()])
    var v = n.target_links[0].value
    var id = get_new_index(links)

    //var tgt = node_by_name["waste_"+(n.column+1).toString()]
    var tgt = node_by_name["waste"]
    var l = new structs.Link(id,n,tgt,v,n.target_links.reference)
    n.source_links.push(l)
    tgt.target_links.push(l)
    l.is_loss=true
    links[id]=l

    //move_node(n,nn)
  })
  */


  globals.simple_sources.forEach( (item)=>{
    var ind = Object.values(nodes).find( (n)=> {return n.name==="primary "+item} )
    ind.source_amts[item] = ind.get_value()
    populateAmts(ind,item,'source_amts',true)
    populateAmts(ind,item,'source_amts',false)
  })

  globals.simple_sectors.forEach( (item)=>{
    var ind = Object.values(nodes).find( (n)=> {return n.name===item +" sector"} )
    ind.sector_amts[item] = ind.get_value()
    populateAmts(ind,item,'sector_amts',true)
    //populateAmts(ind,item,'sector_amts',false)
  })

  return {'compoundNodes':compoundNodes,
          'links':links,
          'node_by_name':node_by_name
         }
}


export default exports



//////////////////
// WEBPACK FOOTER
// ./src/store/data.js
// module id = null
// module chunks = 